import GrtLoading from '@/components/GrtLoading/GRTLoading';
import { useEffect } from 'react';
import { handleThirdLogin } from '@/api/login';
import { getJumpBusinessParamsApi } from '@/api/teachTemplate';
import withRouter from '@/components/withRouter';
import { updateCookie } from '@/utils/index';
import { isMobile } from 'react-device-detect';
import Toast from '@/components/Toast';
const HigherEducationLogin = (props) => {
    let code = 'nj-fdy',
        ak = props.searchParams.get('ak'),
        random = props.searchParams.get('_'),
        r = props.searchParams.get('r'),
        access_token = props.searchParams.get('access_token'),
        p = props.searchParams.get('p');
    // 第三方登录成功之后获取跳转业务页面所需参数
    const getToBusinessParams = async (plan_id) => {
        let { code ,data,msg} = await getJumpBusinessParamsApi({
            plan_id
        });
        if (code === '00000') {
            console.log('data',data);
            const { protocol, host } = window.location;
            let url = `/web/player/lectureHall-play?template_id=${data.template_id}&business_id=${data.business_id}&plan_id=${plan_id}&live_hall_id=${data.live_hall_id}&version=${data.version}&is_higher_education=1`;
            if(isMobile){
                let searchParams = `live_id=${data?.live_hall_id}&type=3&rel_plan_id=${plan_id}&rel_business_id=${data.business_id}&rel_template_id=${data.template_id}&version=${data.version}&is_higher_education=1`;
                url = `/mobile/live?${searchParams}`;
            }
            window.location.replace(`${protocol}//${host}${url}`);
        } else {
            Toast.error(msg || '登录失败');
        }
    },
    thirdLogin = async () => {
        let res = await handleThirdLogin({code,ak,random,r,access_token,p});
        if (res.code === '00000') {
            updateCookie(Object.assign(res?.data, { domain: window.location.host }));
            getToBusinessParams(res?.data?.data_id);
        } else {
            Toast.error(res.msg || '登录失败');
        }
    };
    useEffect(() => {
        if (code) {
            thirdLogin();
        }
    }, [code]);
    return (
        <div style={{ height: window.innerHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <GrtLoading></GrtLoading>
        </div>
    );
};

export default withRouter(HigherEducationLogin);
